// Shared core utilities for Prompt Fragments
// Keep this file framework-agnostic and isomorphic (can run on server or client)

export type PromptFragmentCategory =
  | 'system'
  | 'style'
  | 'safety'
  | 'format'
  | 'structure'
  | 'modifier'

export interface AssistantPromptConfig {
  userEditablePrompt: string
  selectedFragmentIds: string[]
}

export const normalizeCategory = (input: string): PromptFragmentCategory => {
  const v = (input || '').toLowerCase()
  if (
    v === 'system' ||
    v === 'style' ||
    v === 'safety' ||
    v === 'format' ||
    v === 'structure' ||
    v === 'modifier'
  )
    return v
  return 'modifier'
}

// Canonical category order used across client and server when composing prompts
export const CATEGORY_ORDER: PromptFragmentCategory[] = [
  'system',
  'safety',
  'style',
  'format',
  'structure',
  'modifier'
]
